import { Col, Row } from "react-bootstrap";
import moment from "moment/min/moment-with-locales";

export default function ScheduleCheckHourSummaryRow({ item }) {
    return (
        <Row className="py-1 border-bottom ">
            <Col className=" text-center fw-bold">
                {moment(item.hour_from, "H").format("LT")} - {moment(item.hour_from, "H").endOf("hour").format("LT")}
            </Col>
            <Col className=" text-center">{item.added}</Col>
            <Col className=" text-center">{item.removed}</Col>
        </Row>
    );
}
